<script lang="ts">
  import { UNNAMED_NAME } from '../../game/constants/world';

  interface Props {
    host: string;
    following: boolean;
    followingName: string;
    viewWidth: number;
    onleave: () => void;
  }

  const { host, following, followingName, viewWidth, onleave }: Props = $props();

  const target = $derived(followingName === '' ? UNNAMED_NAME : followingName);
</script>

<!--
  In the HUD layer, in UI pixels, so a fixed offset below the base-health band clears it at every
  viewport — which is the whole reason it is here and not `position: fixed` in CSS pixels.
-->
<div class="spectator" data-testid="spectator-bar">
  <div class="spectator__row">
    <span class="spectator__label">{host === '' ? 'Spectating' : `Spectating ${host}`}</span>
    <button class="wis-btn spectator__leave" type="button" onclick={onleave}>Leave</button>
  </div>
  <p class="spectator__state" data-testid="spectator-follow">
    {following ? `Following ${target}` : 'Free camera'} · {viewWidth} across
  </p>
  <p class="spectator__keys">WASD or screen edge to pan · wheel to zoom · click a ship to follow</p>
</div>

<style>
  .spectator {
    position: absolute;
    top: 80px;
    left: 10px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px 12px;
    color: #e6ebf7;
    background: linear-gradient(#242423, #171716);
    box-shadow:
      inset 0 1px 0 rgb(255 255 255 / 26%),
      0 2px 6px rgb(0 0 0 / 70%);
    pointer-events: auto;
  }

  .spectator__row {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .spectator__label {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .spectator__leave {
    margin-left: auto;
    padding: 4px 14px;
  }

  .spectator__state {
    margin: 0;
    font-size: 11px;
    color: #77eeff;
  }

  .spectator__keys {
    margin: 0;
    font-size: 9px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #97a0b6;
  }
</style>
